import React, { Dispatch, SetStateAction, useState } from "react";
import { Button, Menu, MenuItem } from "@mui/material";
import { LuMoreVertical } from "react-icons/lu";
import ImportExcelButton from "../../../components/common/modal/ImportExcelButton";
import ModalExportExcel from "../../../components/common/modal/ModalExportExcel";
import { ListType } from "../../../types/list.type";
import ModalDuplicateRow from "../../../components/common/modal/ModalDuplicateRow";

interface IOptions {
  category: ListType;
  setLoad: Dispatch<SetStateAction<number>>;
}

function Options({ category, setLoad }: IOptions) {
  const [anchorMenu, setAnchorMenu] = useState<HTMLButtonElement | null>(null);
  const [openImportExcel, setOpenImportExcel] = useState(false);
  const [openExportExcel, setOpenExportExcel] = useState(false);
  const [openModalDuplicate, setOpenModalDuplicate] = useState(false);

  const handleCloseMenu = () => {
    setAnchorMenu(null);
  };

  return (
    <>
      {openImportExcel && (
        <ImportExcelButton
          open={openImportExcel}
          handleClose={() => setOpenImportExcel(false)}
          apiCode={category?.apiCode}
          setLoad={setLoad}
          columns={category?.columns}
        />
      )}
      {/* {openExportExcel && (
        <ModalExportExcel
          open={openExportExcel}
          handleClose={() => setOpenExportExcel(false)}
          apiCode={category?.apiCode}
          filenameExport={`${category?.apiCode}_export.xlsx`}
        />
      )} */}
      {openModalDuplicate && (
        <ModalDuplicateRow
          apiCode={category?.apiCode}
          open={openModalDuplicate}
          onClose={() => setOpenModalDuplicate(false)}
          columns={category.columns}
          fields={category?.fields || []}
        />
      )}
      <Menu open={!!anchorMenu} anchorEl={anchorMenu} onClose={handleCloseMenu}>
        <MenuItem onClick={() => setOpenImportExcel(true)}>Nhập excel</MenuItem>
        {/* <MenuItem onClick={() => setOpenExportExcel(true)}>Xuất excel</MenuItem> */}
        <MenuItem onClick={() => setOpenModalDuplicate(true)}>
          Kiểm tra trùng dữ liệu
        </MenuItem>
      </Menu>
      {/* Button */}
      <Button
        onClick={(e) => setAnchorMenu(e.currentTarget)}
        variant="contained"
        color="primary"
        size="small"
        sx={{
          boxShadow: "none",
          color: "common.white",
          textTransform: "none",
          "&:hover": { boxShadow: "none" },
        }}
        startIcon={<LuMoreVertical size={16} />}
      >
        Tùy chọn
      </Button>
    </>
  );
}

export default Options;
